import Swal from 'sweetalert2';

/** Merkevare: blå (#005379), svart, hvit — matcher `main.scss` $techblue */
const acDefaults = {
	background: '#ffffff',
	color: '#000000',
	confirmButtonColor: '#005379',
	cancelButtonColor: '#000000',
	denyButtonColor: '#000000',
	buttonsStyling: true,
};

/**
 * SweetAlert2 med AC-standardfarger. Bruk i stedet for `alert()`.
 * @param {import('sweetalert2').SweetAlertOptions} options
 */
export function acSwal(options) {
	return Swal.fire({ ...acDefaults, ...options });
}

/** Enkel tekst-/tittel-dialog med én OK-knapp */
export function acAlert(text, title = '') {
	return acSwal({
		title: title || undefined,
		text,
		confirmButtonText: 'OK',
	});
}
